import React from 'react'

import { Button, XStack } from '@zet/design-system'
import { B16 } from '@zet/integration-flow/components/typography'

interface BottomSheetActionsProps {
  onReset: () => void
  onApply: () => void
}

export const BottomSheetActions: React.FC<BottomSheetActionsProps> = ({
  onReset,
  onApply,
}) => {
  return (
    <XStack className="justify-between items-center my-2">
      <Button
        className="rounded-full w-[48%] bg-secondary-50 hover:bg-secondary-50"
        // style={{ backgroundColor: '#FDE8C9' }}
        onPress={onReset}
      >
        <B16 className="text-[#AD8444]">Reset all</B16>
      </Button>
      <Button
        className="rounded-full w-[48%] bg-secondary-100 hover:bg-secondary-100"
        // style={{ backgroundColor: '#CEA15A' }}
        onPress={onApply}
      >
        <B16 className="text-black">Apply</B16>
      </Button>
    </XStack>
  )
}
